/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/landing.vue'
import Home from '../views/home'
import Employee from '../views/employee'
import Order from '../views/order'
import Payment from '../views/payment'
import Product from '../views/product'
import Setting from '../views/setting'
import Store from '../store/index'
import Setup from '../views/setup'
import CassOrderDetail from "../components/page/CassOrderDetail";

Vue.use(VueRouter)

const middleware = {
  anonymous (to, from, next) {
    if (!Store.getters['account/isLogin']) {
      return next()
    } else {
      next({ name: 'Home' })
    }
  },
  authenticated (to, from, next) {
    if (Store.getters['account/isLogin']) {
      return next()
    } else {
      next({ name: 'Landing' })
    }
  },
  owner (to, from, next) {
    if (Store.getters['account/isOwner']) {
      return next()
    } else {
      next({ name: 'Home' })
    }
  },
  admin (to, from, next) {
    if (Store.getters['account/isAdmin']) {
      return next()
    } else {
      next({ name: 'Home' })
    }
  },
  seller (to, from, next) {
    if (Store.getters['account/isSeller']) {
      return next()
    } else {
      next({ name: 'Home' })
    }
  },
  analyst (to, from, next) {
    if (Store.getters['account/isAnalyst']) {
      return next()
    } else {
      next({ name: 'Home' })
    }
  }
}

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    // beforeEnter: middleware.anonymous
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: middleware.authenticated
  },
  {
    path: '/employee',
    name: 'Employee',
    component: Employee,
    // beforeEnter: middleware.admin
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    // beforeEnter: middleware.seller
  },
  {
    path: '/orders/:order_id',
    name: 'CassOrderDetail',
    component: CassOrderDetail,
    // beforeEnter: middleware.seller
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    // beforeEnter: middleware.admin
  },
  {
    path: '/product',
    name: 'Product',
    component: Product,
    // beforeEnter: middleware.admin
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
    // beforeEnter: middleware.admin
  },
  {
    path: '/setup',
    name: 'Setup',
    component: Setup,
    // beforeEnter: middleware.admin
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
